import { render, staticRenderFns } from "./GithubActivity.vue?vue&type=template&id=29d81830&"
import script from "./GithubActivity.vue?vue&type=script&lang=js&"
export * from "./GithubActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports